import React from 'react';

export const Image = ({ src, alt = 'img', width, height, className }) => {
  return <img src={src} alt={alt} width={width} height={height} className={className} />;
};
